var React = require('react');

function IconClose (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,"\n      .close-inner {\n        fill: #fff;\n      }\n    ")),React.createElement("g",{"id":"close-inner","key":1},React.createElement("path",{"className":"close-inner","d":"M30.51753,30.52a3.99556,3.99556,0,0,1-5.65,0l-9.02-9.02-9.02,9.02a3.99871,3.99871,0,0,1-5.65-5.66l9.02-9.02-9.02-9.02a3.99517,3.99517,0,0,1,5.65-5.65l9.02,9.02,9.01-9.02a3.99871,3.99871,0,0,1,5.66,5.65l-9.02,9.02,9.02,9.02A3.98957,3.98957,0,0,1,30.51753,30.52Z"}))]);
}

IconClose.defaultProps = {"id":"close","viewBox":"0 0 31.69504 31.69002"};

module.exports = IconClose;

IconClose.default = IconClose;
